import React from 'react'
 import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
 import EditUserList from './EditUserList';
import Breadcrumbs from '../../../../common-elements/breadcrumbs/Breadcrumbs';


function EditContainer() {
    const { id } = useParams();
    console.log(id,"userlist");
    
    const {t}=useTranslation()
  
    return (
      <>
      
        <Breadcrumbs
        mainTitle= {id ? t("EditOrganizationAdmin") :""}
        parents={[
          { label: t("Users")},
          {
            label: t("organizationAdmin"),
            link: `${process.env.PUBLIC_URL}/users/organizationAdmin`,
          },
        ]}
      />
        <Container fluid>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <EditUserList/>
                 
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }

export default EditContainer
